import React from 'react';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import Loadable from 'react-loadable';
import LoginView from './views/LoginView/LoginView';
import TokenLoginView from './views/LoginView/TokenLoginView';
import AppBarLoader from 'components/Loaders/AppBarLoader';

import ModalProvider from 'components/Modals/ModalProvider';
import NotificationsProvider from 'components/Notifications/NotificationsProvider';
import TooltipProvider from 'components/Tooltips/TooltipProvider';

import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import TouchBackend from 'react-dnd-touch-backend';

/**
 * Welcome to react. React is a state-based HTML templating engine that lets
 * you write your html right inside your javascript classes. You can also
 * write your own "HTML" components essentially, which can quite honestly
 * get as advanced as you want.
 * 
 * Here, we are using 'react-router' npm library which lets us manage which
 * components are rendered based on the URL of the address bar.
 * 
 * ex.
 * 
 * '/primary/*' will start here as this is the first component mounted in our DOM.
 * 
 * It will enter the <Switch> component statement, which will pick ONE route from the list to match.
 * It will match the /primary route (path), and render the PrimaryView component that I made.
 * 
 * From within there, you can keep nesting deeper and deeper URLs to get as many subroutes
 * as you want.
 */

 /**
  * This is a great example of a simple class. (Also, you only see custom components here, but
  * you could totally write <div>, <span>, whatever you want here.) 
  * 
  * A react class is a regular javascript class, that extends a React.Component and has a
  * render() method. Whatever is returned there, is returned to the HTML.
  *
  * Visit `https://reactjs.org/docs/react-component.html` to read about what class instance methods
  * are available during the React Component lifecycle. (Each of these components are essentially
  * living, breathing html components. Its a lot of fun!) That article essentially covers the entirety
  * of React in a nutshell.
  *
  * Visit `https://reactjs.org/docs/state-and-lifecycle.html` to understand how to update html / classes
  * state of the react component through events / user actions.
  *
  * Of course, reading the entire `https://reactjs.org/docs/hello-world.html` getting started guide on
  * react would be the smartest use of your time to get acquainted.
  */

let DragDropBackend = HTML5Backend;
if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
  DragDropBackend = TouchBackend({ enableTouchEvents: true, enableMouseEvents: true });
}

const LoadablePrimaryView = Loadable({
  loader: () => import('./views/PrimaryView/PrimaryView.js'),
  loading: AppBarLoader
});
const LoadableTeacherView = Loadable({
  loader: () => import('./views/TeacherView/TeacherView.js'),
  loading: AppBarLoader
});
const LoadableAdminView = Loadable({
  loader: () => import('./views/AdminView/AdminView.js'),
  loading: AppBarLoader
});

window.addEventListener('touchstart', function() {
  window.isTouch = true;
});

class App extends React.Component {
  render() {
    return (
      <DragDropContextProvider backend={DragDropBackend}>
        <NotificationsProvider>
          <TooltipProvider>
            <ModalProvider>
              <Switch>
                <Route path="/primary" component={LoadablePrimaryView} />
                <Route path="/teacher" component={LoadableTeacherView} />
                <Route path="/admin" component={LoadableAdminView} />
                <Route path="/login" component={LoginView} />
                <Route path="/tokenlogin" component={TokenLoginView} />
                <Route path="/logout" render={() => {
                  let expires = new Date(0);
                  let domain = document.domain;
                  let oldDomain = '';

                  document.cookie = "Authorization=;path=/;expires="+expires;

                  do {
                    document.cookie = "Authorization=;path=/;expires="+expires+";domain="+domain;
                    document.cookie = "Authorization=;path=/;expires="+expires+";domain=."+domain;
                    oldDomain = domain;
                    domain = domain.replace(/^[^.]+\./, "");
                  } while (domain !== oldDomain);

                  console.log("domain cookie: " + document.cookie);

                  let cloudRef = localStorage.getItem('cloud-referrer');
                  if (cloudRef) {
                    localStorage.removeItem('cloud-referrer');
                    window.location.assign(cloudRef);
                  } else {
                    window.location.pathname = '/';
                  }
                  sessionStorage.clear();
                  return <div />
                }} />
                <Route path="/" render={() => <Redirect to="/login" />} />
              </Switch>
            </ModalProvider>
          </TooltipProvider>
        </NotificationsProvider>
      </DragDropContextProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js